/**
 * Date range picker using MUI X Date Pickers Pro.
 * Single control for "From" and "To" dates; value is [startDate, endDate].
 */
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { DateRangePicker as MuiDateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { Box, InputLabel, useTheme } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

export default function LXDateRangePicker(props) {
  const {
    disabled = false,
    format = "MM/dd/yyyy",
    id = "date-range-picker",
    label = "Date range",
    labelPlacement = "top",
    onChange,
    slotProps = {},
    useExternalLabel = true,
    value = [null, null],
  } = props;

  const theme = useTheme();
  const { palette = {} } = theme;
  const typography = palette?.typography ?? {};

  const [start, end] = Array.isArray(value)
    ? [value[0] ?? null, value[1] ?? null]
    : [null, null];

  const handleChange = (newRange) => {
    if (typeof onChange === "function") {
      const [newStart, newEnd] = newRange ?? [null, null];
      onChange(newStart, newEnd);
    }
  };

  return (
    <Box
      sx={
        labelPlacement === "start"
          ? { display: "flex", alignItems: "center" }
          : {}
      }
    >
      {useExternalLabel && label ? (
        <Box
          sx={{
            color: typography?.secondary,
            display: "flex",
            fontFamily: "Lato",
            fontWeight: "bold !important",
            justifyContent: "space-between",
            lineHeight: 1,
            marginBottom: labelPlacement === "start" ? "inherit" : ".5rem",
            marginTop: labelPlacement === "start" ? "inherit" : ".2rem",
            marginRight: labelPlacement === "start" ? ".5rem" : "",
          }}
        >
          <InputLabel
            sx={{
              color: typography?.secondary,
              fontFamily: "Lato",
              fontWeight: "bold",
            }}
          >
            {label}
          </InputLabel>
        </Box>
      ) : null}

      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <MuiDateRangePicker
          disabled={disabled}
          format={format}
          id={id}
          label={useExternalLabel ? undefined : label}
          onChange={handleChange}
          value={[start, end]}
          slotProps={{
            textField: {
              size: "small",
              ...slotProps?.textField,
            },
            ...slotProps,
          }}
          sx={{ width: "100%" }}
        />
      </LocalizationProvider>
    </Box>
  );
}
